export enum ActivePanelEnum {
    AppointmentPanel = 'appointment-panel',
    InboxPanel = 'inbox-panel',
    InvolvedPartyPanel = 'betrokkenen-panel',
    PhotoPanel = 'foto-panel',
    PaperworkPanel = 'paperwork-panel',
    ClaimNotificationPanel = 'claim-notification-panel',
    PendingActionsPanel = 'pending-actions-panel',
}
